module.exports = __webpack_public_path__ + "static/media/flacidez.8cfc399a.jpg";